__turbopack_context__.v({
  "numericRating": "ProductRatingStars-module-scss-module__3yfXiW__numericRating",
  "partialStarContainer": "ProductRatingStars-module-scss-module__3yfXiW__partialStarContainer",
  "partialStarFill": "ProductRatingStars-module-scss-module__3yfXiW__partialStarFill",
  "partialStarOutline": "ProductRatingStars-module-scss-module__3yfXiW__partialStarOutline",
  "ratingRow": "ProductRatingStars-module-scss-module__3yfXiW__ratingRow",
  "ratingText": "ProductRatingStars-module-scss-module__3yfXiW__ratingText",
  "reviewCount": "ProductRatingStars-module-scss-module__3yfXiW__reviewCount",
  "root": "ProductRatingStars-module-scss-module__3yfXiW__root",
  "sizeLarge": "ProductRatingStars-module-scss-module__3yfXiW__sizeLarge",
  "sizeMedium": "ProductRatingStars-module-scss-module__3yfXiW__sizeMedium",
  "star": "ProductRatingStars-module-scss-module__3yfXiW__star",
  "starSizeLarge": "ProductRatingStars-module-scss-module__3yfXiW__starSizeLarge",
  "starSizeMedium": "ProductRatingStars-module-scss-module__3yfXiW__starSizeMedium",
  "stars": "ProductRatingStars-module-scss-module__3yfXiW__stars",
});
